module.exports = __webpack_public_path__ + "img/icon_rotate_right.3e6b115e.png";